export const SELF_SERVICE_ROUTE_PREFIX = '/self-service';

export const ROUTES_SELF_SERVICE = {
  OVERVIEW: `${SELF_SERVICE_ROUTE_PREFIX}/overview`,
  BOOKINGS: `${SELF_SERVICE_ROUTE_PREFIX}/bookings`,
  QUOTES: `${SELF_SERVICE_ROUTE_PREFIX}/quotes`,
  PROFILE: `${SELF_SERVICE_ROUTE_PREFIX}/profile`,
  LOGIN: `${SELF_SERVICE_ROUTE_PREFIX}/login`,
  SSOLOGINSUCCESS: `${SELF_SERVICE_ROUTE_PREFIX}/successful`,
  SSOLOGINFAIL: `${SELF_SERVICE_ROUTE_PREFIX}/unsuccessful`,
  DOCUMENTS: `${SELF_SERVICE_ROUTE_PREFIX}/documents`,
  PAYMENTFORM: `${SELF_SERVICE_ROUTE_PREFIX}/payment-form`,
  PAYMENTSTATUS: `${SELF_SERVICE_ROUTE_PREFIX}/payment-status`,
  PAYMENTSTATUSNOSESSION: `${SELF_SERVICE_ROUTE_PREFIX}/payment-status-no-session`
};
